var render = function render(){var _vm=this,_c=_vm._self._c;return _c('riskWarn',{attrs:{"domain":"labor","pageTitle":"用工合规预警","themeColor":"#7C5CFF","subTabs":['合同签订合规', '未签合同已发薪', '长期服务用工', '社保补缴风险'],"showAmount":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }